export default class Config {

    static config = {};

    static setConfig(config) {
        this.config = config;
    }

    static getConfig() {
        return this.config;
    }

    static get(name, defaultValue) {
        if (name in this.config) {
            return this.config[name];
        }

        return defaultValue ? defaultValue : null;
    }

    static set(key, value) {
        this.config[key] = value;
    }
}